import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import WorkItemsSimpleTable from '@Components/Tables/WorkItemsSimpleTable'
import RootStore from '@App/stores/root-store'

const SubmissionBulkStep = () => {
    const { bulkUploadStore, workStore } = useContext<RootStore>(StoresContext)

    useEffect(
        () => () => {
            workStore.destroyDraftWork()
        },
        []
    )

    const worksSubmissionsCurrent = bulkUploadStore.allWorksFromUpload

    if (!worksSubmissionsCurrent) {
        return <></>
    }

    return (
        <div className="submission-bulk-step">
            <div className="submission-bulk-head">
                <h2>{`${worksSubmissionsCurrent.completeCount} work registration${
                    worksSubmissionsCurrent.completeCount !== 1 ? 's' : ''
                } submitted!`}</h2>
                <p>You can view the status of these submissions in your Registration History.</p>
            </div>
            {worksSubmissionsCurrent.errorCount > 0 && (
                <div className="error-work-wrapper">
                    <p>
                        You have{' '}
                        <span>{`${worksSubmissionsCurrent.errorCount} work${
                            worksSubmissionsCurrent.errorCount !== 1 ? 's' : ''
                        }
                        left with errors`}</span>
                    </p>
                    <WorkItemsSimpleTable workModelList={worksSubmissionsCurrent.error} valid={false} disableView />
                </div>
            )}
        </div>
    )
}

export default observer(SubmissionBulkStep)
